import { useEffect, useState } from "react";
import type { LabReportFile } from "@ferrivia/api-contract";
import { useApi } from "@ferrivia/auth-web";

export type CustomerLabReportFilesState =
  | { status: "loading" }
  | { status: "error" }
  | { status: "success"; files: LabReportFile[] };

/* One fetch per time the pane opens and no polling, for the same reason as
   useCustomerLabs: each call writes a käyttöloki row for the staff member who
   read it, and a background refresh would log reads nobody performed. */
export function useCustomerLabReportFiles(id: string | undefined, enabled: boolean): CustomerLabReportFilesState {
  const api = useApi();
  const [state, setState] = useState<CustomerLabReportFilesState>({ status: "loading" });

  useEffect(() => {
    if (!id || !enabled) {
      return;
    }
    let cancelled = false;
    setState({ status: "loading" });
    api.patients
      .labReportFiles(id)
      .then((files) => {
        if (!cancelled) setState({ status: "success", files });
      })
      .catch(() => {
        if (!cancelled) setState({ status: "error" });
      });
    return () => {
      cancelled = true;
    };
  }, [api, id, enabled]);

  return state;
}
